import * as URLConfig from "@frameworks/web/config/domain";
const config = URLConfig.config;
const base = "market/";
const MutualFundsConfigURL = {
    getMutualFundsSchemes: config.jmw +
        config.jmw_market_env +
        config.jmw_market +
        base +
        "get-mf-details",
    exploreFunds: config.jmw +
        config.jmw_market_env +
        config.jmw_market +
        base +
        "mf-sub-categories",
    fundsHouse: config.jmw + config.jmw_market_env + config.jmw_market + base + "amc-funds",
};
export default MutualFundsConfigURL;
